import { Reducer, Subscription, Effect } from 'umi'
import { levelEquityList } from '@/services/memberLevel'
import moment from 'moment'

export interface LevelZoneModelState {}
export interface LevelZoneType {
  namespace: 'LevelZone'
  state: LevelZoneModelState
  effects: {
    getData: Effect
  }
  reducers: {
    setData: Reducer<LevelZoneModelState>
  }
  subscriptions?: { setup: Subscription }
}
const LevelZoneModel: LevelZoneType = {
  namespace: 'LevelZone',
  state: {
    baseInfo: {
      levelName: '', // 等级名称
      memberMobile: '', // 用户手机号码
      levelExpirationEnd: moment().format('YYYY/MM-DD'), // 过期时间
      equityCategoryRespList: [], // 不分组权益
      levelEquityGroupRespList: [], // 分组权益
      productCategoryRespList: [], // 不分组商品
      levelProductGroupRespList: [], // 分组商品
      totalCommonUerPoint: 0, // 通兑点数
    },
  },
  effects: {
    *getData({ payload, callback }, { call, put }) {
      const res: any = yield levelEquityList()
      const { levelType, templateType } = res
      yield put({
        type: 'setData',
        payload: { baseInfo: res },
      })
      callback(levelType, templateType)
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
}
export default LevelZoneModel
